export const ROUTES = {
  // Public routes
  LOGIN: "/login",
  // Private routes
  HOME: "/", // This will be your reports page
  MATRIX: "/reports",
  DEEP_SEARCH: "/deep-search",
  REPORT_DETAIL: "/tenant/:tenantId",
  SUPER_ADMIN: "/super-admin",

  // Wildcard for 404
  NOT_FOUND: "*",
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];

export interface RouteConfig {
  path: string;
  title: string;
  isProtected: boolean;
  showInNavbar?: boolean;
  icon?: string;
  requiresSuperAdmin?: boolean;
}

export const ROUTE_CONFIGS: Record<string, RouteConfig> = {
  [ROUTES.LOGIN]: {
    path: ROUTES.LOGIN,
    title: "Login",
    isProtected: false,
    showInNavbar: false,
  },
  [ROUTES.HOME]: {
    path: ROUTES.HOME,
    title: "Home",
    isProtected: true,
    showInNavbar: true,
    icon: "chart",
  },
  [ROUTES.MATRIX]: {
    path: ROUTES.MATRIX,
    title: "Reports",
    isProtected: true,
    showInNavbar: true,
    icon: "matrix",
  },
  [ROUTES.DEEP_SEARCH]: {
    path: ROUTES.DEEP_SEARCH,
    title: "Deep Research",
    isProtected: true,
    showInNavbar: true,
    icon: "search",
  },
  [ROUTES.REPORT_DETAIL]: {
    path: ROUTES.REPORT_DETAIL,
    title: "Report Details",
    isProtected: true,
    showInNavbar: false,
  },
  [ROUTES.SUPER_ADMIN]: {
    path: ROUTES.SUPER_ADMIN,
    title: "Super Admin",
    isProtected: true,
    showInNavbar: false,
    requiresSuperAdmin: true,
  },
};

// Helper function to get route config
export const getRouteConfig = (path: string): RouteConfig | undefined => {
  return ROUTE_CONFIGS[path];
};

// Helper function to get navbar routes
export const getNavbarRoutes = (): RouteConfig[] => {
  return Object.values(ROUTE_CONFIGS).filter((config) => config.showInNavbar);
};

// Helper function to generate report detail URL
export const getReportDetailUrl = (reportId: string): string => {
  return ROUTES.REPORT_DETAIL.replace(":id", reportId);
};
